import type { AuditLogEvent } from '../../../domain/audit-log-event'

import { AuditLogAction } from '../../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../../domain/audit-log-resource-type.enum'

import { CheckRunRerunResourceColumn } from './check-run-rerun-resource-column'
import { GroupUpdateResourceColumn } from './group-update-resource-column'

interface Props {
  auditLog: AuditLogEvent
}

export const ResourceColumn = (props: Props): JSX.Element => {
  let ResourceColumn

  if (
    props.auditLog.resource?.type === AuditLogResourceType.CheckRun &&
    props.auditLog.action === AuditLogAction.Rerun
  ) {
    ResourceColumn = CheckRunRerunResourceColumn
  } else if (
    props.auditLog.resource?.type === AuditLogResourceType.Group &&
    props.auditLog.action === AuditLogAction.Update
  ) {
    ResourceColumn = GroupUpdateResourceColumn
  } else {
    ResourceColumn = EmptyResourceColumn
  }

  return ResourceColumn && <ResourceColumn auditLog={props.auditLog} />
}

const EmptyResourceColumn = (_props: Props): JSX.Element | null => {
  return null
}
